// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { JOB_BASE_URL } from "../services/jobService";
// import Loading from "../utils/Loading";
// import { format } from "date-fns";
// import { Link, useNavigate } from "react-router-dom";
// import { useAuthContext } from "../hooks/useAuthContext";
// import Swal from "sweetalert2";

// const JobApplication = () => {
//   const [jobs, setJobs] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const { user } = useAuthContext();
//   const navigate = useNavigate();

//   // delete application
//   // const handleDeleteApplication = async (jobId, applicationId) => {
//   //   // alert(jobId, " : ", applicationId);
//   //   try {
//   //     const response = await axios.delete(
//   //       `${JOB_BASE_URL}/api/jobs/apply/delete/${jobId}/applications/${applicationId}`,
//   //       {
//   //         headers: {
//   //           "Content-Type": "application/json",
//   //           Authorization: `Bearer ${user.token}`,
//   //         },
//   //       }
//   //     );
//   //     alert("Application deleted successfully!");
//   //     console.log(response);
//   //   } catch (error) {
//   //     console.error("Error deleting application:", error);
//   //     setError(error.message);
//   //   }
//   // };

//   const handleDeleteApplication = async (e, jobId, applicationId) => {
//     e.preventDefault();
//     // console.log("Job ID:", jobId, "Application ID:", applicationId);
//     console.log("Deleting application:", applicationId);
//     console.log("Deleting from job:", jobId);
//     console.log(
//       "API URL:",
//       `${JOB_BASE_URL}/api/jobs/delete-application/${jobId}/applications/${applicationId}`
//     );

//     try {
//       const confirmResult = await Swal.fire({
//         title: "Are you sure?",
//         text: "You won't be able to revert this!",
//         icon: "warning",
//         showCancelButton: true,
//         confirmButtonColor: "#3085d6",
//         cancelButtonColor: "#d33",
//         confirmButtonText: "Yes, delete it!",
//       });

//       if (confirmResult.isConfirmed) {
//         await axios.delete(
//           `${JOB_BASE_URL}/api/jobs/delete-application/${jobId}/applications/${applicationId}`,
//           {
//             headers: {
//               "Content-Type": "application/json",
//               Authorization: `Bearer ${user.token}`,
//             },
//           }
//         );

//         // Update state to remove deleted application
//         setJobs((prevJobs) =>
//           prevJobs.map((job) =>
//             job._id === jobId
//               ? {
//                   ...job,
//                   applications: job.applications.filter(
//                     (app) => app._id !== applicationId
//                   ),
//                 }
//               : job
//           )
//         );

//         Swal.fire({
//           title: "Deleted!",
//           text: "Application deleted successfully!",
//           icon: "success",
//           timer: 3000,
//         });
//         navigate("/api/jobs/applications");
//       }
//     } catch (error) {
//       console.error("Error deleting application:", error);
//       Swal.fire({
//         title: "Error!",
//         text: `Failed to delete application: ${
//           error.response?.data?.error || error.message
//         }`,
//         icon: "error",
//         timer: 2000,
//       });
//     }
//   };

//   useEffect(() => {
//     axios
//       .get(`${JOB_BASE_URL}/api/jobs/list`)
//       .then((response) => {
//         setJobs(response.data);
//         setLoading(false);
//       })
//       .catch((error) => {
//         console.error("There was an error fetching the data!", error);
//         setError(error.message);
//         setLoading(false);
//       });
//   }, []);

//   // Filter jobs that have at least one application
//   const jobsWithApplications = jobs.filter(
//     (job) => job.applications.length > 0
//   );

//   if (loading) {
//     return <Loading />;
//   }

//   return (
//     <div className="container mt-5">
//       {error && (
//         <div className="alert alert-danger" role="alert">
//           {error}
//         </div>
//       )}
//       <h1 className="bg-white p-2">Applied Jobs</h1>
//       {jobsWithApplications.length > 0 && (
//         <p>Here is the list of jobs you have applied for so far.</p>
//       )}

//       <hr />
//       {jobsWithApplications.length > 0 ? (
//         <div className="row">
//           {jobsWithApplications.map((job) => (
//             <div key={job._id} className="col-lg-3 col-md-4 col-lg-4 mb-4">
//               <div className="card shadow-sm border-light h-100">
//                 <div className="card-body">
//                   {/* Job Title and Company */}
//                   <h5 className="card-title">{job.jobTitle}</h5>
//                   <h6 className="card-subtitle mb-3">{job.companyName}</h6>
//                   <span className="badge bg-success mb-2">Applied</span> <hr />
//                   {/* Job Description */}
//                   <p className="card-text text-truncate">
//                     {job.description.slice(0, 20)}...
//                     <Link
//                       to={`/api/jobs/job-details/${
//                         job._id
//                       }/${job.jobTitle.replace(/\s+/g, "-")}`}
//                       className="text-primary"
//                     >
//                       See more
//                     </Link>
//                   </p>
//                   <hr />
//                   {/* Job Details */}
//                   <ul className="list-group list-group-flush">
//                     <li className="list-group-item">
//                       <strong>Location:</strong> {job.location.city},{" "}
//                       {job.location.state}, {job.location.country}
//                     </li>
//                     <li className="list-group-item">
//                       <strong>Salary:</strong> ${job.salary}
//                     </li>
//                     <li className="list-group-item">
//                       <strong>Employment Type:</strong> {job.employmentType}
//                     </li>
//                     <li className="list-group-item">
//                       <strong>Remote Type:</strong> {job.remoteType}
//                     </li>
//                   </ul>
//                   <hr />
//                   {/* Applications */}
//                   <div className="mt-3">
//                     <h5>Applications:</h5>

//                     {job.applications.map((application) => (
//                       <div
//                         key={application._id}
//                         className="border-bottom pb-3 mb-3"
//                       >
//                         <ul className="list-group list-group-flush">
//                           <li className="list-group-item">
//                             <strong>Applicant ID:</strong>{" "}
//                             {application.applicant}
//                           </li>
//                           <li className="list-group-item">
//                             <strong>Applied At:</strong>{" "}
//                             {format(
//                               new Date(application.appliedAt),
//                               "MMMM d, yyyy"
//                             )}
//                           </li>
//                         </ul>

//                         {/* Delete button inside the application loop */}
//                         {user && (
//                           <button
//                             role="button"
//                             className="btn btn-danger btn-sm"
//                             onClick={(e) =>
//                               handleDeleteApplication(
//                                 e,
//                                 job._id,
//                                 application._id
//                               )
//                             }
//                             // onClick={(e) =>
//                             //   handleDeleteApplication(
//                             //     e,
//                             //     job._id,
//                             //     application._id
//                             //   )
//                             // }
//                           >
//                             <i className="fa fa-trash"></i> Delete
//                           </button>
//                         )}
//                       </div>
//                     ))}

//                     {job.applications.map((application) => (
//                       <div
//                         key={application._id}
//                         className="border-bottom pb-3 mb-3"
//                       >
//                         <ul className="list-group list-group-flush">
//                           <li className="list-group-item">
//                             <strong>Applicant id:</strong>{" "}
//                             {application.applicant}
//                           </li>
//                           <li className="list-group-item">
//                             <strong>Applied At:</strong>{" "}
//                             {format(
//                               new Date(application.appliedAt),
//                               "MMMM d, yyyy"
//                             )}
//                           </li>
//                         </ul>
//                         <hr />

//                         <hr />

//                         {/* Applicant Details  */}
//                         <div className="mt-3">
//                           {job.applications.map((applicant) => (
//                             <div key={applicant._id}>
//                               <h5>Applicant Details:</h5>
//                               <ul className="list-group list-group-flush">
//                                 <li className="list-group-item">
//                                   <strong>First Name:</strong>{" "}
//                                   {applicant.firstName}
//                                 </li>
//                                 <li className="list-group-item">
//                                   <strong>Last Name:</strong>{" "}
//                                   {applicant.lastName}
//                                 </li>
//                                 <li className="list-group-item">
//                                   <strong>Email:</strong> {applicant.email}
//                                 </li>
//                               </ul>
//                             </div>
//                           ))}{" "}
//                         </div>
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>
//       ) : (
//         <div className="alert alert-info">No applied jobs found.</div>
//       )}
//     </div>
//   );
// };

// export default JobApplication;
import React, { useEffect, useState } from "react";
import axios from "axios";
import { JOB_BASE_URL } from "../services/jobService";
import Loading from "../utils/Loading";
import { format } from "date-fns";
import { Link, useNavigate } from "react-router-dom";
import { useAuthContext } from "../hooks/useAuthContext";
import Swal from "sweetalert2";

const JobApplication = () => {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { user } = useAuthContext();
  const navigate = useNavigate();

  const handleDeleteApplication = async (e, jobId, applicationId) => {
    e.preventDefault();
    try {
      const confirmResult = await Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      });

      if (confirmResult.isConfirmed) {
        await axios.delete(
          `${JOB_BASE_URL}/api/jobs/delete-application/${jobId}/applications/${applicationId}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${user.token}`,
            },
          }
        );

        setJobs((prevJobs) =>
          prevJobs.map((job) =>
            job._id === jobId
              ? {
                  ...job,
                  applications: job.applications.filter(
                    (app) => app._id !== applicationId
                  ),
                }
              : job
          )
        );

        Swal.fire({
          title: "Deleted!",
          text: "Application deleted successfully!",
          icon: "success",
          timer: 3000,
        });
      }
    } catch (error) {
      console.error("Error deleting application:", error);
      Swal.fire({
        title: "Error!",
        text: `Failed to delete application: ${
          error.response?.data?.error || error.message
        }`,
        icon: "error",
        timer: 2000,
      });
    }
  };

  useEffect(() => {
    const fetchJobs = async () => {
      try {
        const response = await axios.get(`${JOB_BASE_URL}/api/jobs/list`);
        setJobs(response.data);
      } catch (error) {
        console.error("There was an error fetching the data!", error);
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchJobs();
  }, []);

  // Filter jobs that have at least one application
  const jobsWithApplications = jobs.filter(
    (job) => job.applications?.length > 0
  );

  if (loading) {
    return (
      <div className="d-flex justify-content-center py-5">
        <Loading />
      </div>
    );
  }

  return (
    <div className="container py-5">
      {error && (
        <div className="alert alert-danger alert-dismissible fade show">
          <i className="fa fa-exclamation-circle me-2"></i>
          {error}
          <button
            type="button"
            className="btn-close"
            onClick={() => setError(null)}
          ></button>
        </div>
      )}

      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h2 className="mb-1">
            <i className="fa fa-file-text-o me-2"></i>
            My Job Applications
          </h2>
          {jobsWithApplications.length > 0 && (
            <p className="text-muted mb-0">
              You've applied to {jobsWithApplications.length} job(s)
            </p>
          )}
        </div>
        <Link to="/api/jobs/all-jobs" className="btn btn-outline-primary">
          <i className="fa fa-search me-2"></i>Find More Jobs
        </Link>
      </div>

      <hr className="mb-4" />

      {jobsWithApplications.length > 0 ? (
        <div className="row g-4">
          {jobsWithApplications.map((job) => (
            <div key={job._id} className="col-12">
              <div className="card border-0 shadow-sm">
                <div className="card-header bg-light">
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <h4 className="mb-1">
                        <i className="fa fa-briefcase me-2 text-primary"></i>
                        {job.jobTitle}
                      </h4>
                      <h5 className="text-muted mb-0">
                        <i className="fa fa-building me-2"></i>
                        {job.companyName}
                      </h5>
                    </div>
                    <span className="badge bg-success">
                      <i className="fa fa-check me-1"></i>
                      Applied
                    </span>
                  </div>
                </div>

                <div className="card-body">
                  <div className="row">
                    <div className="col-md-4">
                      <div className="mb-3">
                        <h6 className="text-muted">
                          <i className="fa fa-map-marker me-2"></i>Location
                        </h6>
                        <p className="mb-0">
                          {job.location.city}, {job.location.state},{" "}
                          {job.location.country}
                        </p>
                      </div>

                      <div className="mb-3">
                        <h6 className="text-muted">
                          <i className="fa fa-money me-2"></i>Salary
                        </h6>
                        <p className="mb-0">
                          {new Intl.NumberFormat("en-US", {
                            style: "currency",
                            currency: "USD",
                          }).format(job.salary || 0)}
                        </p>
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="mb-3">
                        <h6 className="text-muted">
                          <i className="fa fa-clock-o me-2"></i>Employment Type
                        </h6>
                        <p className="mb-0">{job.employmentType}</p>
                      </div>

                      <div className="mb-3">
                        <h6 className="text-muted">
                          <i className="fa fa-home me-2"></i>Work Type
                        </h6>
                        <p className="mb-0">{job.remoteType}</p>
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="mb-3">
                        <h6 className="text-muted">
                          <i className="fa fa-calendar me-2"></i>Posted Date
                        </h6>
                        <p className="mb-0">
                          {format(new Date(job.createdAt), "MMMM d, yyyy")}
                        </p>
                      </div>

                      <Link
                        to={`/api/jobs/job-details/${
                          job._id
                        }/${job.jobTitle.replace(/\s+/g, "-")}`}
                        className="btn btn-sm btn-outline-primary"
                      >
                        <i className="fa fa-eye me-1"></i>View Job Details
                      </Link>
                    </div>
                  </div>

                  <hr />

                  <h5 className="mb-3">
                    <i className="fa fa-users me-2"></i>Your Applications
                  </h5>

                  {job.applications.map((application) => (
                    <div
                      key={application._id}
                      className="card mb-3 border-0 bg-light"
                    >
                      <div className="card-body">
                        <div className="row">
                          <div className="col-md-6">
                            <h6>
                              <i className="fa fa-user me-2"></i>Applicant
                              Details
                            </h6>
                            <ul className="list-unstyled">
                              <li>
                                <strong>Name:</strong> {application.firstName}{" "}
                                {application.lastName}
                              </li>
                              <li>
                                <strong>Email:</strong> {application.email}
                              </li>
                              <li>
                                <strong>ID:</strong> {application.applicant}
                              </li>
                            </ul>
                          </div>

                          <div className="col-md-6">
                            <h6>
                              <i className="fa fa-calendar me-2"></i>Application
                              Details
                            </h6>
                            <ul className="list-unstyled">
                              <li>
                                <strong>Applied:</strong>{" "}
                                {format(
                                  new Date(application.appliedAt),
                                  "MMMM d, yyyy 'at' h:mm a"
                                )}
                              </li>
                              <li>
                                <strong>Status:</strong>{" "}
                                <span className="badge bg-info">Submitted</span>
                              </li>
                            </ul>

                            <div className="mt-3">
                              <button
                                className="btn btn-sm btn-danger"
                                onClick={(e) =>
                                  handleDeleteApplication(
                                    e,
                                    job._id,
                                    application._id
                                  )
                                }
                              >
                                <i className="fa fa-trash me-1"></i>Withdraw
                                Application
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="text-center py-5">
          <div className="alert alert-info w-75 mx-auto">
            <i className="fa fa-info-circle fa-2x mb-3"></i>
            <h4>No Applications Found</h4>
            <p className="mb-0">
              You haven't applied to any jobs yet. Browse available jobs to
              apply today!
            </p>
            <Link to="/api/jobs/all-jobs" className="btn btn-primary mt-3 px-4">
              <i className="fa fa-search me-2"></i>Browse Jobs
            </Link>
          </div>
        </div>
      )}
    </div>
  );
};

export default JobApplication;